import Section from "../components/Section";

const files = [
  {
    title: "Guidelines on Haemoglobinopathies in India (NHM, Govt. of India)",
    href: "https://nhm.gov.in/images/pdf/programmes/RBSK/Resource_Documents/Guidelines_on_Hemoglobinopathies_in%20India.pdf",
  },
  {
    title: "Thalassemia International Federation – Patient Education Booklet",
    href: "https://thalassaemia.org.cy/publications/educational-booklets/",
  },
  {
    title: "Care and Management of Transfusion-Dependent Thalassemia (TIF PDF)",
    href: "https://thalassaemia.org.cy/wp-content/uploads/2017/12/TIF-Guidelines-for-TDT-3rd-Edition-English.pdf",
  },
  {
    title: "Thalassemia Information & Resources (Cooley’s Anemia Foundation)",
    href: "https://thalassemia.org/Thalassemia-Information-Resources",
  },
  {
    title: "ThalInd: Web-based Resource for β-Thalassemia Mutations in India",
    href: "http://ccg.murdoch.edu.au/thalind",
  },
  {
    title: "Zero Thalassemia Foundation – Awareness & Testing Materials",
    href: "https://zerothalassemiafoundation.org/resources",
  },
  {
    title: "WHO – Thalassemia Fact Sheet",
    href: "https://www.who.int/news-room/fact-sheets/detail/thalassaemia",
  },
  {
    title: "NACO Blood Donation Guidelines",
    href: "https://naco.gov.in/sites/default/files/NACO-Blood-Donation-Guidelines.pdf",
  },
  {
    title: "Indian Council of Medical Research (ICMR) Genetic Counselling Resources",
    href: "https://www.icmr.nic.in/content/human-genetics",
  },
];

export default function Resources() {
  return (
    <Section
      eyebrow="Resources"
      title="Downloads & Links"
      subtitle="Trusted educational materials, medical guidelines, and awareness resources."
    >
      <ul className="grid md:grid-cols-3 gap-4">
        {files.map((f, i) => (
          <li key={i} className="rounded-xl border p-5 bg-white shadow-sm">
            <div className="font-semibold text-slate-900">{f.title}</div>
            <a
              className="mt-2 inline-block text-rose-700 hover:underline"
              href={f.href}
              target="_blank"
              rel="noreferrer"
            >
              Open Resource →
            </a>
          </li>
        ))}
      </ul>
    </Section>
  );
}
